exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.navbar-text[data-v-6e47db12] {\n    padding: 0 10px;\n}\n", "", {"version":3,"sources":["/Users/soslanbolotaev/project/brunch_system-crm/src/views/src/views/NewOrderLayout.vue"],"names":[],"mappings":";AAwBA;IACA,gBAAA;CACA","file":"NewOrderLayout.vue","sourcesContent":["<template>\n    <div>\n        <navbar-header page-name=\"Колл-центр\"/>\n        <order-info class=\"body\"></order-info>\n    </div>\n</template>\n\n<script>\nimport NavbarHeader from '@/components/NavbarHeader'\nimport OrderInfo from '@/components/OrderInfo'\nexport default {\n  name: 'NewOrderLayout',\n  data () {\n    return {\n    }\n  },\n  components: {\n    OrderInfo,\n    NavbarHeader\n  }\n}\n</script>\n\n<style scoped>\n    .navbar-text {\n        padding: 0 10px;\n    }\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e47db12","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/NewOrderLayout.vue
// module id = gZOc
// module chunks = 1